import { Select } from 'tea-component';
import React, {useEffect, useMemo, useState} from 'react';
import moment from 'moment/moment';
import type { IColumnInfo } from '@dbl/core/dataSource';
import { moment2String } from '@/pages/datalab/components/SortableDrag/utils';
import { TimeRangePicker } from '@/pages/datalab/components/FilterPicker/TimeRangePicker';
import {useDblIntl} from "@/pages/datalab/utils/utils";

export const TimeOptions = [
  {
    value: 'Day',
    text: '按天',
    text_en: 'By day',
  },
  {
    value: 'Week',
    text: '按周',
    text_en: 'By week',
  },
  {
    value: 'Month',
    text: '按月',
    text_en: 'By month',
  },
  {
    value: 'aggregate',
    text: '聚合',
    text_en: 'Aggregate',
  },
];

export function FilterBasicTime(props: {
  column: IColumnInfo;
  onChange: (columnInfo: IColumnInfo) => void;
  style?: any;
}) {
  const { column, onChange, style } = props;
  const { dblFormatMessage: explorationFormatMessage, isEn} = useDblIntl("exploration");
  const [timeOption, setTimeOption] = useState(column.column_granularity);
  const [timeValue, setTimeValue] = useState<any[]>(column.column_value ?? []);

  useEffect(() => {
    setTimeOption(column.column_granularity);
    setTimeValue(column.column_value ?? []);
  }, [JSON.stringify(column.column_value), column.column_granularity]);

  useEffect(() => {
    if (timeOption == '') {
      setTimeOption('Day');
      return;
    }
    const newColumn = { ...column };
    newColumn.operation = 'between';
    newColumn.column_granularity = timeOption;
    onChange(newColumn);
  }, [timeOption, JSON.stringify(column)]);

  useEffect(() => {
    if (timeValue.length === 0) {
      const endTime = moment();
      const beginTime = moment().subtract(6, 'day');
      setTimeValue([moment2String(beginTime, undefined), moment2String(endTime, undefined)]);
      return;
    }
    const newColumn = { ...column };
    newColumn.operation = 'between';
    newColumn.column_value = timeValue;
    onChange(newColumn);
  }, [JSON.stringify(timeValue), JSON.stringify(column)]);
  
  const options = useMemo(() => TimeOptions.map((opt) => ({value: opt.value, text: isEn ? opt.text_en : opt.text})), [isEn]);

  return (
    <div className="indicators-select" style={{ ...style, display: 'flex' }}>
      <Select
        style={{ marginRight: '10px' }}
        appearance="button"
        options={options}
        value={timeOption}
        onChange={(value) => setTimeOption(value)}
      />
      <TimeRangePicker
        value={timeValue}
        onConfirmBack={(value: any) => {
          setTimeValue(value);
        }}
        language={isEn ? "en" : "cn"}
      />
    </div>
  );
}
